import React, { useState, useEffect } from "react";
import { Icons } from "../../atoms/Icons";
import { Card, Col } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./uploaddoc-modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";

const UploadDocModal = (props) => {
  const [documentStatus, setDocumentStatus] = useState({ documentlist: [] });
  const [uploadError, setUploadError] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const { uploadDocFetching, uploadDocData } = useSelector(
    (state) => state.uploadDoc,
  );
  const { data } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  // prettier-ignore
  const { uploadDocument, submitDocument } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const finalSubmit = () => {
    if (fileNames.length <= 0) {
      return;
    }
    const payload = {
      investorId: props?.investorId,
      workItemType: data?.updateJourneyInfo?.workItem,
      ismrtReferenceId: data?.updateJourneyInfo?.ismrtReferenceId,
      journeyId: data?.updateJourneyInfo?.journeyId,
    };
    // const response = {
    //   memberId: "TPTMP21696677",
    //   investorId: "21696677",
    //   message: "Document uploded",
    // };
    submitDocument(props?.investorId, payload);
    //dispatch({ type: "SUBMIT_DOC_PATCH_SUCCESS", data: response });
  };
  const onInputClick = (event) => {
    event.target.value = "";
  };
  const uploadFile = (e) => {
    const file = e?.target?.files[0];
    const extension = file?.type;
    if (
      extension === "application/pdf" ||
      extension === "image/png" ||
      extension === "image/jpeg"
    ) {
      if (fileNames?.includes(file?.name)) {
        alert("file already exists");
      } else {
        const formData = new FormData();
        formData.append("document", file);
        setFileNames((prevState) => [...prevState, file?.name]);
        uploadDocument(
          props?.investorId,
          data?.updateJourneyInfo?.journeyId,
          formData,
        )
          .then(() => {
            setUploadError(false);
          })
          .catch(() => {
            setUploadError(true);
            setFileNames((prevState) =>
              prevState.filter((name) => name !== file?.name),
            );
          });
      }
    } else {
      alert("Incorrect file type");
    }
  };
  useEffect(() => {
    if (Object.keys(uploadDocData).length > 0 && !uploadError) {
      setDocumentStatus((prevState) => ({
        documentlist: [...prevState.documentlist, uploadDocData],
      }));
    }
  }, [uploadDocData, uploadError]);
  return (
    <div className="document-upload-modal-container">
      <a className="qr-status-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </a>
      <Col xs={12}>
        <Card className="status-card pt-4">
          {/* <Icons iconname="tick" /> */}
          <Card.Body className="p-0">
            <Card.Title className="status-title">
              To update your personal detail, we require you to upload a
              document
            </Card.Title>
            {uploadDocFetching ? (
              <div className="upload-doc-loader"></div>
            ) : (
              <Card.Text className="status-text">
                <label htmlFor="files" className="upload-btn">
                  <Icons iconname="external-link" variant="icon-twelve-px" />
                  <span className="upload-label">
                    Click here to{" "}
                    <a style={{ textDecoration: "underline" }}>browse files</a>
                  </span>
                </label>
              </Card.Text>
            )}
            <input
              id="files"
              onChange={uploadFile}
              onClick={onInputClick}
              accept="application/pdf, image/*"
              style={{ visibility: "hidden" }}
              type="file"
            />
            {documentStatus &&
              fileNames?.length > 0 &&
              documentStatus?.documentlist?.map((list, index) => {
                if (fileNames[index]) {
                  return (
                    <div key={index} className="uploaded-document">
                      <span className="document">
                        <div className="document-name">{fileNames[index]}</div>
                      </span>
                      <span className="document-status">
                        {list?.message === "Document received" ? (
                          <span className="document-status-pass">
                            {list?.message}
                          </span>
                        ) : (
                          <span className="document-status-fail">
                            {list?.message}
                          </span>
                        )}
                      </span>
                    </div>
                  );
                }
              })}
          </Card.Body>
          <Card.Footer className="upload-footer mt-4">
            {!uploadDocFetching ? (
              <Buttons
                className="primary"
                name="Submit document"
                handleClick={finalSubmit}
                style={fileNames?.length > 0 ? {} : { cursor: "not-allowed" }}
              />
            ) : (
              ""
            )}
          </Card.Footer>
        </Card>
      </Col>
    </div>
  );
};

export default UploadDocModal;
